import { useState } from 'react';
import { GovIcon, GovToast } from '@gov-design-system-ce/react';
import type { ToastMessageSubscription } from '@gov-nx/core/events';
import { useMessageEvents } from '@gov-nx/core/events';
import { createUuid4 } from '@gov-nx/utils/common';
import { MarkdownRender } from '../Markdown/MarkdownRender';
import { useGlobalLocale } from '@gov-nx/core/service';
import { useMatomo } from '@mitresthen/matomo-tracker-react';

export const ToastMessageListener = () => {
	const { trackEvent } = useMatomo();
	const [toast, setToast] = useState<
		ToastMessageSubscription['payload'] & { id: string }
	>();

	const deleteToast = () => setToast(undefined);
	const { t } = useGlobalLocale();

	useMessageEvents({
		onToastMessage: (_, payload) => {
			if (payload.options.color === 'error') {
				trackEvent({ category: 'toast', action: 'error' });
			}
			setToast({ ...payload, id: createUuid4('toast') });
		},
	});

	if (!toast) {
		return null;
	}

	return (
		<GovToast
			key={toast.id}
			color={toast.options.color ?? 'primary'}
			aria-live="assertive"
			role="alert"
			type={toast.options.type}
			gravity={toast.options.gravity ?? 'bottom'}
			position={toast.options.position ?? 'center'}
			time={toast.options.time ?? 10000}
			closeLabel={toast.options.closeLabel}
			accessibleCloseLabel={t('akce.wcag.zavrit-oznameni')}
			icon={
				toast.options.icon ? (
					<GovIcon
						name={toast.options.icon.name}
						type={toast.options.icon.type}
						color={toast.options.icon.color}
						size={toast.options.icon.size}
					/>
				) : null
			}
			onClose={deleteToast}>
			<MarkdownRender
				onInternalLinkClick={deleteToast}
				applyClasses={{
					link:
						toast.options.color !== 'warning'
							? 'text-(--text-white-fixed)!'
							: 'text-(--text-black-fixed)!',
				}}>
				{toast.content}
			</MarkdownRender>
		</GovToast>
	);
};
